import { Box, Stack, Typography } from "@mui/material";
import React, { FC } from "react";
import { useTheme } from "@mui/material/styles";
import DashboardInfo from "./DashboardInfo";
import { data } from "../../data/dashboard";
import DashboardTable from "./DashboardTable";
import useResponsive from "../../hooks/useResponsive";

import DashboardCharts from "./DashboardCharts";
import { DashboardStats } from "../../interface/dashboard";

const DashboardContent: FC<{
  facility_list: any[];
  loading: boolean;
  stats: DashboardStats;
}> = ({ facility_list, stats, loading }) => {
  const theme = useTheme();
  const isSmall = useResponsive("down", "sm", "xl");

  return (
    <Stack sx={{ padding: 2, marginTop: 20 }}>
      <DashboardInfo stats={stats} />
      {/* <DashboardCharts /> */}
      <Box sx={{}}>
        <DashboardTable
          data={facility_list.filter((val, id) => id < 5)}
          loading={loading}
        />
      </Box>
    </Stack>
  );
};

export default DashboardContent;
